import { z } from "zod";
import {
  MSP_DOCUMENT_CATEGORY_VALUES,
  MSP_DOCUMENT_DIFFICULTY_VALUES,
  type MspDocumentCategory,
  type MspDocumentDifficulty,
} from "@/lib/constants/msp-doc-enums";

export {
  MSP_DOCUMENT_CATEGORY_VALUES,
  MSP_DOCUMENT_DIFFICULTY_VALUES,
  type MspDocumentCategory,
  type MspDocumentDifficulty,
};

export const documentSchema = z
  .object({
    title: z.string().min(1, "Title is required").max(255, "Title too long"),
    content: z.string().min(1, "Content is required"),
    excerpt: z.string().optional(),
    category: z.enum(MSP_DOCUMENT_CATEGORY_VALUES),
    tags: z.array(z.string()).default([]),
    client_id: z
      .string()
      .optional()
      .transform((val) => (val === "" ? undefined : val)),
    company_id: z
      .string()
      .optional()
      .transform((val) => (val === "" ? undefined : val)),
    difficulty: z.enum(MSP_DOCUMENT_DIFFICULTY_VALUES).default("beginner"),
    is_internal: z.boolean().default(true),
    is_featured: z.boolean().default(false),
    estimated_read_time: z.preprocess((val) => {
      if (val === "" || val === null || val === undefined) return undefined;
      const num = Number(val);
      return isNaN(num) ? undefined : num;
    }, z.number().int().positive().optional()),
    shared_with_users: z.array(z.string()).default([]),
  })
  .refine(
    (data) => {
      if (data.category === "client-specific" && !data.client_id && !data.company_id) {
        return false;
      }
      return true;
    },
    {
      message: "A company or contact is required for customer-specific documents",
      path: ["client_id"],
    }
  );

export type DocumentFormData = z.infer<typeof documentSchema>;
